<!-- 竞猜冠军 -->
<template>
<el-dialog
    class="ball-style"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
       
        <div class="close" @click="closeHandler"><img :src="require('../assets/close-gavy.png')" alt="" height="26"></div>
        <div class="title-head">
            <div class="main">预测冠军</div>
            
        </div>
        <ul class="all-team">
            <li v-for="(item,index) in list" :key="index" :class="{check:index == checkIndex}" @click="checkIndex = index">
                <div class="box">
                    <div class="team-ico"><img :src="item.imageUrl" alt=""></div>
                    <div class="name">{{item.name}}</div>
                    <div class="pre">赔率{{item.odds}}倍</div>
                </div>
            </li>
        </ul>
        <div class="ensure" @click="championBetStatus = true" v-if="list[checkIndex]">预测{{list[checkIndex].name||''}}为冠军</div>
    </div>
    <GoldGuessingChampionBet :status.sync="championBetStatus" :info="list[checkIndex]" @success="closeHandler"/>
</el-dialog>
</template>
<script>
import GoldGuessingChampionBet from './guessing-champion-bet.vue';
export default {
    name:'GuessingChampionGold',
    props:['status'],
    components:{GoldGuessingChampionBet},
    data(){
        return {
            list:[],
            checkIndex:0,
            championBetStatus:false,
        }
    },
    created(){
        this.getTeamList();
    },
    methods:{
        closeHandler(){
            this.$emit('update:status',false)
        },
        async getTeamList(){
            let result = await this.$axios.get('/worldcup2022/gold/coin/champion/game/all/teams')
            console.log('球队列表---->',result)
            this.list = result.data.teams;
        }

    }
}
</script>
<style lang="less" scoped>
.ball-style{
    /deep/.el-dialog{width:700px; background: none; border-radius: 10px; background: url(../assets/dialog-bg.png) no-repeat right top #ff4400; background-size:100% ; padding:15px;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .ball-style{

        /deep/.el-dialog{width:90%}
    }
}

.ball-cup-container{
    background: #fff; border-radius: 10px; position: relative;border-radius: 10px 10px 0 0 ; padding: 20px 30px;
    .close{position: absolute; right: 20px; top: 10px; cursor: pointer;}
    .title-head{
        margin-bottom: 10px; display: flex; align-items: center;
        .main{font-size: 18px; line-height: 24px; color: #111; font-weight: 600; margin-right: 10px;}
        .subf{font-size: 16px; line-height: 24px; color: #999;}

    }
}
.all-team{
    display: flex; flex-wrap: wrap; margin: 0 -30px; max-height: 400px; overflow: auto;
    li{
        width: 20%; padding: 0 15px; margin-bottom: 10px; box-sizing: border-box;  user-select: none; cursor: pointer;
        .box{
            padding: 12px; border-radius: 10px; overflow: hidden;
            .team-ico{border: 1px solid #eee;
                img{display: block;}
            }
            .name{font-size: 14px; line-height: 20px; color: #111;font-weight: 500; margin-top: 5px; text-align: center;}
            .pre{font-size: 14px; line-height: 20px; color: #999; text-align: center;}
        }
        &.check{
            .box{
                position: relative;
                &:before{
                    content:''; position: absolute; left:0; top: 0; right: 0; bottom: 0;border:2px solid  #FF4E14; border-radius: 10px;
                }
                &:after{
                    content: ''; position: absolute; right: -1px; bottom: -1px; background: url(../assets/checked.png) no-repeat right bottom; width:31px; height: 24px; background-size: 100%;
                }

            }
        }
    }
}
.ensure{
    background: linear-gradient(180deg,#fae344, #f8c968 52%, #f9c411);
    border-radius: 10px; display: flex; align-items: center; justify-content: center; height: 54px;  font-size: 20px; color: #7D540B; font-weight: 600; user-select: none; cursor: pointer;
    &:hover{
      
        background-image: linear-gradient(180deg,#FFE01D, #E7A41C 52%, #EBB500);;
    }
}

@media screen and (max-width:768px){
    .ball-style{
        /deep/.el-dialog{padding:10px;}
    }
    .ball-cup-container{padding: 20px;}
    .all-team{
        margin: 0 -20px;
        li{
            width:25%; padding: 0 5px;
            .name{font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;}
            .box{
                padding: 5px;   
                .pre{font-size: 12px;}
            }
        }
    }
    .ensure{
        font-size: 16px; height: 46px;
    }
}
</style>